/* ======================================================================
   O.C. Hairclinic — Theme JS
   Zentrales Skript für alle O.C.-Section-Interaktionen.
   Wird via <script src="{{ 'oc-theme.js' | asset_url }}" defer></script> in theme.liquid geladen.
   ====================================================================== */


/* === Section: arztberatung-buchen === */
(function(){
document.querySelectorAll('.oc-ab').forEach(function(root) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('.oc-ab__city-card'));
    var btns = Array.prototype.slice.call(root.querySelectorAll('.oc-ab__city-btn'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.oc-ab__panel'));
    var support = root.querySelector('.oc-ab__support');
    var defaultCity = root.dataset.defaultCity || 'darmstadt';
    var storageKey = 'oc-arztberatung-city';

    function loadIframe(panel) {
      var iframe = panel.querySelector('.oc-ab__iframe');
      if (!iframe || iframe.dataset.loaded === '1') return;
      var src = iframe.getAttribute('data-src');
      if (!src) return;
      var skeleton = panel.querySelector('.oc-ab__skeleton');
      iframe.addEventListener('load', function() {
        iframe.dataset.loaded = '1';
        if (skeleton) skeleton.setAttribute('hidden', '');
      }, { once: true });
      iframe.src = src;
    }

    function activate(city, persist) {
      var match = false;
      var activeBtn = null;
      btns.forEach(function(b) {
        var on = b.dataset.city === city;
        b.setAttribute('aria-selected', on ? 'true' : 'false');
        b.setAttribute('tabindex', on ? '0' : '-1');
        var card = b.closest('.oc-ab__city-card');
        if (card) card.classList.toggle('is-active', on);
        if (on) { match = true; activeBtn = b; }
      });
      if (!match) return false;

      // Flow-Routing: Typeform-Cities zeigen das shared 'typeform'-Panel, ClinicCore-Cities das stadt-spezifische
      var flow = (activeBtn && activeBtn.dataset.flow) || 'clinicore';
      var targetPanelKey = (flow === 'typeform') ? 'typeform' : city;

      var activePanel = null;
      panels.forEach(function(p) {
        var on = p.dataset.cityPanel === targetPanelKey;
        if (on) {
          p.removeAttribute('hidden');
          loadIframe(p);
          activePanel = p;
        } else {
          p.setAttribute('hidden', '');
        }
      });

      // Typeform-Panel dynamisch befüllen (Stadt-Name + Adresse)
      if (flow === 'typeform' && activePanel && activeBtn) {
        var label = activeBtn.dataset.cityLabel || '';
        var addr = activeBtn.dataset.cityAddr || '';
        var nameEl = activePanel.querySelector('[data-tf-city-name]');
        var addrEl = activePanel.querySelector('[data-tf-city-addr]');
        if (nameEl) nameEl.textContent = 'Wunschtermin in ' + label;
        if (addrEl) addrEl.textContent = addr;
      }

      // WhatsApp-Support-Box bei Typeform-Flow ausblenden (konkurrierender CTA direkt drunter)
      if (support) {
        if (flow === 'typeform') support.setAttribute('hidden', '');
        else support.removeAttribute('hidden');
      }

      if (persist) {
        try { localStorage.setItem(storageKey, city); } catch (e) {}
        if (activePanel) {
          var isMobile = window.innerWidth < 1024;
          setTimeout(function() {
            activePanel.scrollIntoView({
              behavior: 'smooth',
              block: isMobile ? 'start' : 'nearest'
            });
          }, 120);
        }
      }
      return true;
    }

    btns.forEach(function(b) {
      b.addEventListener('click', function() {
        activate(b.dataset.city, true);
      });
      b.addEventListener('keydown', function(e) {
        var idx = btns.indexOf(b);
        var target = null;
        if (e.key === 'ArrowRight') target = btns[(idx + 1) % btns.length];
        if (e.key === 'ArrowLeft')  target = btns[(idx - 1 + btns.length) % btns.length];
        if (target) {
          e.preventDefault();
          target.focus();
          activate(target.dataset.city, true);
        }
      });
    });

    function detectInitialCity() {
      var hash = (location.hash || '').replace(/^#/, '');
      if (hash) {
        var m = hash.match(/^arztberatung-buchen-(.+)$/);
        if (m && m[1]) return m[1];
        if (btns.some(function(b) { return b.dataset.city === hash; })) return hash;
      }
      try {
        var stored = localStorage.getItem(storageKey);
        if (stored) return stored;
      } catch (e) {}
      return defaultCity;
    }

    var initial = detectInitialCity();
    if (!activate(initial, false)) {
      activate(defaultCity, false);
    }

    window.addEventListener('hashchange', function() {
      var c = detectInitialCity();
      activate(c, false);
    });

    // Mobile-Slider: Counter „X / N" beim Wischen updaten
    var grid = root.querySelector('.oc-ab__city-grid');
    var counter = root.querySelector('[data-city-counter]');
    var cityCards = grid ? grid.querySelectorAll('.oc-ab__city-card') : [];
    if (grid && counter && cityCards.length) {
      var ticking = false;
      grid.addEventListener('scroll', function() {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function() {
          if (window.innerWidth >= 640) { ticking = false; return; }
          var gridLeft = grid.getBoundingClientRect().left;
          var bestIdx = 0;
          var bestDist = Infinity;
          cityCards.forEach(function(c, i) {
            var dist = Math.abs(c.getBoundingClientRect().left - gridLeft);
            if (dist < bestDist) { bestDist = dist; bestIdx = i; }
          });
          counter.textContent = (bestIdx + 1);
          ticking = false;
        });
      }, { passive: true });
    }
  });
})();

/* === Section: arztberatung-care-manager === */
(function(){
document.querySelectorAll('.oc-cmtool').forEach(function(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('.oc-cmtool__tab'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('.oc-cmtool__panel'));
    var defaultCity = root.dataset.defaultCity || 'darmstadt';
    var storageKey = 'oc-cmtool-last-city';

    function loadIframe(panel) {
      var iframe = panel.querySelector('.oc-cmtool__iframe');
      if (!iframe || iframe.dataset.loaded === '1') return;
      var src = iframe.getAttribute('data-src');
      if (!src) return;
      var skeleton = panel.querySelector('.oc-cmtool__skeleton');
      iframe.addEventListener('load', function() {
        iframe.dataset.loaded = '1';
        if (skeleton) skeleton.setAttribute('hidden', '');
      }, { once: true });
      iframe.src = src;
    }

    function activate(city, persist) {
      var match = false;
      var activeTab = null;
      tabs.forEach(function(t) {
        var on = t.dataset.city === city;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.setAttribute('tabindex', on ? '0' : '-1');
        if (on) { match = true; activeTab = t; }
      });
      if (!match) return false;

      // Flow-Routing: Typeform-Standorte zeigen das shared 'typeform'-Panel, Clinicore das stadt-spezifische
      var flow = (activeTab && activeTab.dataset.flow) || 'clinicore';
      var targetPanelKey = (flow === 'typeform') ? 'typeform' : city;

      var activePanel = null;
      panels.forEach(function(p) {
        var on = p.dataset.cityPanel === targetPanelKey;
        if (on) {
          p.removeAttribute('hidden');
          loadIframe(p);
          activePanel = p;
        } else {
          p.setAttribute('hidden', '');
        }
      });

      // Typeform-Panel: Stadt-Name + Adresse dynamisch befüllen
      if (flow === 'typeform' && activePanel && activeTab) {
        var label = activeTab.dataset.cityLabel || '';
        var venue = activeTab.dataset.cityVenue || '';
        var addr = activeTab.dataset.cityAddr || '';
        var nameEl = activePanel.querySelector('[data-tf-city-name]');
        var venueEl = activePanel.querySelector('[data-tf-city-venue]');
        var addrEl = activePanel.querySelector('[data-tf-city-addr]');
        var mapsEl = activePanel.querySelector('[data-tf-city-maps]');
        if (nameEl) nameEl.textContent = label;
        if (venueEl) venueEl.textContent = venue;
        if (addrEl) addrEl.textContent = addr;
        if (mapsEl && addr) mapsEl.href = 'https://www.google.com/maps/search/?api=1&query=' + encodeURIComponent(addr);
      }

      if (persist) {
        try { localStorage.setItem(storageKey, city); } catch (e) {}
        if (history.replaceState) {
          history.replaceState(null, '', '#' + city);
        }
      }
      return true;
    }

    tabs.forEach(function(t) {
      t.addEventListener('click', function() {
        activate(t.dataset.city, true);
      });
      t.addEventListener('keydown', function(e) {
        var idx = tabs.indexOf(t);
        var target = null;
        if (e.key === 'ArrowRight') target = tabs[(idx + 1) % tabs.length];
        if (e.key === 'ArrowLeft')  target = tabs[(idx - 1 + tabs.length) % tabs.length];
        if (e.key === 'Home')       target = tabs[0];
        if (e.key === 'End')        target = tabs[tabs.length - 1];
        if (target) {
          e.preventDefault();
          target.focus();
          activate(target.dataset.city, true);
        }
      });
    });

    document.addEventListener('keydown', function(e) {
      var t = e.target;
      if (!t) return;
      var tag = t.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || t.isContentEditable) return;
      if (e.metaKey || e.ctrlKey || e.altKey || e.shiftKey) return;
      var n = parseInt(e.key, 10);
      if (!isNaN(n) && n >= 1 && n <= tabs.length) {
        var tab = tabs[n - 1];
        if (tab) {
          e.preventDefault();
          tab.focus();
          activate(tab.dataset.city, true);
        }
      }
    });

    var initial = (location.hash || '').replace('#', '');
    if (!initial) {
      try { initial = localStorage.getItem(storageKey) || ''; } catch (e) {}
    }
    if (!initial || !activate(initial, false)) {
      activate(defaultCity, false);
    }
  });
})();

/* === Section: expert-concerns === */
(function(){
(function () {
    const section = document.querySelector('.oc-concern');
    if (!section) return;
    const modal = section.querySelector('[data-modal]');
    const modalVideo = section.querySelector('[data-modal-video]');
    const modalTitle = section.querySelector('[data-modal-title]');
    const modalClose = section.querySelector('[data-modal-close]');
    const triggers = section.querySelectorAll('.oc-concern__media[data-video-src]');

    function openModal(src, title) {
      if (!src) return;
      modalVideo.src = src;
      modalTitle.textContent = title || '';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      modalVideo.play().catch(function(){});
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.load();
      document.body.style.overflow = '';
    }
    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.dataset.videoSrc, btn.dataset.videoTitle);
      });
    });
    modalClose.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  })();
})();

/* === Section: expertenwissen-library === */
(function(){
(function () {
    var root = document.querySelector('.oc-exlib');
    if (!root) return;

    /* ---------- Filter ---------- */
    var filter = root.querySelector('[data-exlib-filter]');
    var grid = root.querySelector('[data-exlib-grid]');
    var empty = root.querySelector('[data-exlib-empty]');
    if (filter && grid) {
      var pills = filter.querySelectorAll('.oc-exlib__pill');
      var cards = grid.querySelectorAll('.oc-exlib__card');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          var target = pill.getAttribute('data-filter');
          pills.forEach(function (p) {
            var active = p === pill;
            p.classList.toggle('is-active', active);
            p.setAttribute('aria-selected', active ? 'true' : 'false');
          });
          var visible = 0;
          cards.forEach(function (card) {
            var tags = (card.getAttribute('data-tags') || '').split(/\s+/);
            var show = target === 'all' || tags.indexOf(target) !== -1;
            card.classList.toggle('is-hidden', !show);
            if (show) visible++;
          });
          if (empty) empty.hidden = visible > 0;
        });
      });
    }

    /* ---------- Auto-Duration aus Video-Metadaten (wenn duration leer gelassen) ---------- */
    function formatDuration(sec) {
      if (!isFinite(sec) || sec <= 0) return '';
      var s = Math.round(sec);
      if (s < 60) return s + ' Sek';
      return Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0') + ' Min';
    }
    root.querySelectorAll('.oc-exlib__card[data-video-src]').forEach(function (card) {
      var badge = card.querySelector('.oc-exlib__duration');
      if (!badge || badge.textContent.trim()) return;
      var probe = document.createElement('video');
      probe.preload = 'metadata';
      probe.muted = true;
      probe.src = card.dataset.videoSrc;
      probe.addEventListener('loadedmetadata', function () {
        var auto = formatDuration(probe.duration);
        if (auto) badge.textContent = auto;
      });
    });

    /* ---------- Modal ---------- */
    var modal = root.querySelector('[data-modal]');
    var modalVideo = root.querySelector('[data-modal-video]');
    var modalTitle = root.querySelector('[data-modal-title]');
    var modalClose = root.querySelector('[data-modal-close]');
    var triggers = root.querySelectorAll('.oc-exlib__card[data-video-src]');

    function openModal(src, title) {
      if (!src) return;
      modalVideo.src = src;
      modalTitle.textContent = title || '';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      modalVideo.play().catch(function(){});
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.load();
      document.body.style.overflow = '';
    }
    triggers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.dataset.videoSrc, btn.dataset.videoTitle);
      });
    });
    if (modalClose) modalClose.addEventListener('click', closeModal);
    if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('is-open')) closeModal();
    });
  })();
})();

/* === Section: founders-intro === */
(function(){
(function () {
    const section = document.querySelector('.oc-founders');
    if (!section) return;

    const modal = section.querySelector('[data-modal]');
    const modalVideo = section.querySelector('[data-modal-video]');
    const modalTitle = section.querySelector('[data-modal-title]');
    const modalClose = section.querySelector('[data-modal-close]');
    const thumbs = section.querySelectorAll('.oc-founders__thumb[data-video-src]');

    function openModal(src, title) {
      if (!src) return;
      modalVideo.src = src;
      modalTitle.textContent = title || '';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      modalVideo.play().catch(function(){});
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.load();
      document.body.style.overflow = '';
    }

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        openModal(btn.dataset.videoSrc, btn.dataset.videoTitle);
      });
    });
    modalClose.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeModal();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  })();
})();

/* === Section: header === */
(function(){
(function () {
  var header = document.querySelector('[data-oc-header]');
  if (!header) return;

  // Shrink-on-scroll
  var setScrolled = function () {
    if (window.scrollY > 8) header.setAttribute('data-oc-scrolled', 'true');
    else header.removeAttribute('data-oc-scrolled');
  };
  setScrolled();
  window.addEventListener('scroll', setScrolled, { passive: true });

  // Trust-Stripe rotate
  var slots = header.querySelectorAll('.oc-header__trust-slot');
  if (slots.length > 1) {
    var idx = 0;
    setInterval(function () {
      slots[idx].classList.remove('is-active');
      idx = (idx + 1) % slots.length;
      slots[idx].classList.add('is-active');
    }, 5000);
  }

  // Mega-Menü Hover (Desktop) + Click (a11y)
  var megaItems = header.querySelectorAll('.oc-header__nav-item.has-mega');
  var closeAllMegas = function () {
    megaItems.forEach(function (it) {
      it.classList.remove('is-open');
      var btn = it.querySelector('.oc-header__nav-link');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  };
  megaItems.forEach(function (item) {
    var btn = item.querySelector('.oc-header__nav-link');
    var closeTimer;
    item.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      closeAllMegas();
      item.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
    });
    item.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () {
        item.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
      }, 180);
    });
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var open = item.classList.contains('is-open');
      closeAllMegas();
      if (!open) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllMegas();
  });

  // Drawer
  var drawer = document.getElementById('oc-drawer');
  var openBtns = header.querySelectorAll('[data-oc-drawer-open]');
  var closeEls = drawer ? drawer.querySelectorAll('[data-oc-drawer-close]') : [];
  var openDrawer = function () {
    if (!drawer) return;
    drawer.hidden = false;
    requestAnimationFrame(function () { drawer.classList.add('is-open'); });
    document.body.style.overflow = 'hidden';
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
  };
  var closeDrawer = function () {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
    openBtns.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    setTimeout(function () { drawer.hidden = true; }, 320);
  };
  openBtns.forEach(function (b) { b.addEventListener('click', openDrawer); });
  closeEls.forEach(function (b) { b.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeDrawer();
  });

  // Drawer-Accordion
  if (drawer) {
    var accs = drawer.querySelectorAll('[data-oc-acc]');
    accs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
  }
})();
})();

/* === Section: klinik-team === */
(function(){
(function () {
    const section = document.querySelector('.oc-klt');
    if (!section) return;
    const rail = section.querySelector('.oc-klt__rail');
    if (!rail) return;
    section.querySelectorAll('[data-rail-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        const direction = btn.getAttribute('data-rail-nav') === 'next' ? 1 : -1;
        const step = rail.clientWidth * 0.7;
        rail.scrollBy({ left: direction * step, behavior: 'smooth' });
      });
    });
  })();
})();

/* === Section: patient-hub === */
(function(){
(function () {
    var root = document.querySelector('.oc-phub');
    if (!root) return;
    var filter = root.querySelector('[data-phub-filter]');
    var grid = root.querySelector('[data-phub-grid]');
    var empty = root.querySelector('[data-phub-empty]');
    if (!filter || !grid) return;

    var pills = filter.querySelectorAll('.oc-phub__pill');
    var cards = grid.querySelectorAll('.oc-phub__card');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var target = pill.getAttribute('data-filter');

        pills.forEach(function (p) {
          var active = p === pill;
          p.classList.toggle('is-active', active);
          p.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        var visible = 0;
        cards.forEach(function (card) {
          var tags = (card.getAttribute('data-tags') || '').split(/\s+/);
          var show = target === 'all' || tags.indexOf(target) !== -1;
          card.classList.toggle('is-hidden', !show);
          if (show) visible++;
        });

        if (empty) empty.hidden = visible > 0;
      });
    });
  })();
})();

/* === Section: patient-story-gallery === */
(function(){
(function () {
    const section = document.querySelector('.oc-pgal');
    if (!section) return;
    const lightbox = section.querySelector('[data-lightbox]');
    const lbImg = section.querySelector('[data-lightbox-img]');
    const lbClose = section.querySelector('[data-lightbox-close]');
    const items = section.querySelectorAll('.oc-pgal__item');

    function open(src, alt) {
      lbImg.src = src;
      lbImg.alt = alt || '';
      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');
      lbImg.removeAttribute('src');
      document.body.style.overflow = '';
    }
    items.forEach(function (btn) {
      btn.addEventListener('click', function () {
        open(btn.dataset.full, btn.dataset.alt);
      });
    });
    lbClose.addEventListener('click', close);
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) close(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && lightbox.classList.contains('is-open')) close();
    });
  })();
})();

/* === Section: patient-story-video === */
(function(){
(function () {
    const section = document.querySelector('.oc-pvideo');
    if (!section) return;
    const frame = section.querySelector('.oc-pvideo__frame');
    const modal = section.querySelector('[data-modal]');
    const modalVideo = section.querySelector('[data-modal-video]');
    const modalClose = section.querySelector('[data-modal-close]');
    if (!frame || !modal) return;

    function openModal() {
      const src = frame.dataset.videoSrc;
      if (!src) return;
      modalVideo.src = src;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      modalVideo.play().catch(function(){});
    }
    function closeModal() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      modalVideo.pause();
      modalVideo.removeAttribute('src');
      modalVideo.load();
      document.body.style.overflow = '';
    }
    frame.addEventListener('click', openModal);
    modalClose.addEventListener('click', closeModal);
    modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
  })();
})();

/* === Section: uber-standorte === */
(function(){
(function () {
    var section = document.querySelector('.oc-ust');
    if (!section) return;
    var rail = section.querySelector('.oc-ust__rail');
    if (!rail) return;
    section.querySelectorAll('[data-rail-nav]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var direction = btn.getAttribute('data-rail-nav') === 'next' ? 1 : -1;
        var step = rail.clientWidth * 0.7;
        rail.scrollBy({ left: direction * step, behavior: 'smooth' });
      });
    });
  })();
})();

/* === Section: uber-story === */
(function(){
(function(){
  var root = document.querySelector('.oc-us');
  if (!root) return;
  var trigger = root.querySelector('[data-video-trigger]');
  var modal = root.querySelector('[data-video-modal]');
  var video = root.querySelector('[data-video-el]');
  if (!trigger || !modal || !video) return;

  function open(){
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    try { video.currentTime = 0; video.play(); } catch(e){}
  }
  function close(){
    modal.hidden = true;
    document.body.style.overflow = '';
    try { video.pause(); } catch(e){}
  }
  trigger.addEventListener('click', open);
  root.querySelectorAll('[data-video-close]').forEach(function(el){ el.addEventListener('click', close); });
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !modal.hidden) close(); });
})();
})();

/* === Section: ugc-strip === */
(function(){
(function () {
    var root = document.querySelector('.oc-ugc');
    if (!root) return;
    var rail = root.querySelector('[data-ugc-rail]');
    var prev = root.querySelector('[data-ugc-prev]');
    var next = root.querySelector('[data-ugc-next]');
    if (!rail) return;
    function step() {
      var firstTile = rail.querySelector('.oc-ugc__tile');
      if (!firstTile) return 400;
      return firstTile.offsetWidth + 20;
    }
    if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { rail.scrollBy({ left:  step() * 2, behavior: 'smooth' }); });
  })();
})();
